import React, { useEffect, useState } from 'react'
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import ReCAPTCHA from 'react-google-recaptcha';
import styles from './ReCaptcha.module.scss'
import Loading from "./Loading";

let ref = React.createRef();

function ReCaptcha(props) {

    const {onExpired, onErrored, onChange, className} = props;
    const propClass = className ? ` ${className}` : '';

    const [loading, setLoading] = useState(false);

    useEffect(() => {setLoading(true);}, [props.dark]);
    useEffect(() => {
        if (!!loading) setLoading(false);
    }, [loading]);

    const reset = () => {
        if (!!ref && !!ref.current) ref.current.reset();
    }

    if (!!loading) return <Loading type='component'/>

    return (
        <ReCAPTCHA
            className={`${styles.captcha}${propClass}`}
            sitekey={process.env.NEXT_PUBLIC_GOOGLE_RECAPTCHA_SITEKEY}
            hl='en'
            theme={props.dark ? 'dark' : 'light'}
            onExpired={() => {
                reset();
                if (onExpired) onExpired();
            }}
            onErrored={response => {
                if (onErrored) onErrored(response);
            }}
            onChange={onChange}
            ref={el => {
                if (props.getRef) props.getRef(el);
                ref = el;
            }}
        />
    );
}

ReCaptcha.propTypes = {
    onExpired: PropTypes.func,
    onErrored: PropTypes.func,
    onChange: PropTypes.func,
    className: PropTypes.string,
    getRef: PropTypes.func,
    dark: PropTypes.bool,
}

const mapStateToProps = state => ({
    dark: state.UI.theme.dark,
})

export default connect(mapStateToProps)(ReCaptcha)